export default '/pricing/subscription/payment';
